"use client";

import { useEffect, useState } from "react";
import useStore from "@/store/useStore";
import MaintenanceMode from "./MaintenanceMode";
import Image from "next/image";
import FadeTransition from "@/components/ui/fade-transition";

export default function MaintenanceCheck({ children }) {
  const { checkMaintenanceMode, isMaintenanceMode, isMaintenanceModeLoading } =
    useStore();
  const [show, setShow] = useState(true);

  useEffect(() => {
    checkMaintenanceMode();
  }, [checkMaintenanceMode]);

  useEffect(() => {
    if (!isMaintenanceModeLoading) {
      setShow(false);
    }
  }, [isMaintenanceModeLoading]);

  if (isMaintenanceModeLoading) {
    return (
      <FadeTransition show={show}>
        <div className="fixed inset-0 flex items-center justify-center bg-white">
          <div className="animate-pulse">
            <Image
              src="/logos/beta/purple.svg"
              alt="Qensa Logo"
              width={200}
              height={50}
              priority
            />
          </div>
        </div>
      </FadeTransition>
    );
  }

  if (isMaintenanceMode) {
    return <MaintenanceMode />;
  }

  return children;
}
